import LoadingStatus from '@libs/loading-status';

import {
  CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_FAILURE,
  CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_REQUEST,
  CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_SUCCESS,
  CONTRACT_AUTHENTICATION_INITIALIZE,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

type ContractAuthenticationGuideCheckLoadingStatusState = LoadingStatus;

const initialState: ContractAuthenticationGuideCheckLoadingStatusState = LoadingStatus.IDLE;

export default function reducer(
  state: ContractAuthenticationGuideCheckLoadingStatusState = initialState,
  action: ContractAuthenticationAction
): ContractAuthenticationGuideCheckLoadingStatusState {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return LoadingStatus.IDLE;
    case CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_REQUEST:
      return LoadingStatus.PENDING;
    case CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_SUCCESS:
      return LoadingStatus.SUCCEEDED;
    case CONTRACT_AUTHENTICATION_DIGITAL_CERTIFICATE_GUIDE_CHECK_FAILURE:
      return LoadingStatus.FAILED;
    default:
      return state;
  }
}
